/* unplugin-vue-components disabled */import { render } from "./MyMicropost.vue?vue&type=template&id=1e163306&scoped=true"
import script from "./MyMicropost.vue?vue&type=script&lang=js"
export * from "./MyMicropost.vue?vue&type=script&lang=js"

import "./MyMicropost.vue?vue&type=style&index=0&id=1e163306&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Public\\object\\xvideos-frontend\\mysex\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e163306"]])

export default __exports__